export default __webpack_public_path__ + "static/mytennisroster-logo-9660521b8dcbadd46e1ce28379956e9a.svg";